import { render, staticRenderFns } from "./tally-order-detail.vue?vue&type=template&id=d90f0114&"
import script from "./tally-order-detail.vue?vue&type=script&lang=js&"
export * from "./tally-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports